module.exports = __webpack_public_path__ + "img/close.91d7088e.svg";